import React from 'react'
import './footer.css'

export default function Footer() {
    return (
        <div className='footer-container'>
            <div className='footer-content'>
                &copy; Copyright 2019, ChefBoyRT, LLC
            </div>
        </div>
    )
}
